export default __webpack_public_path__ + "static/media/battery.0c898b54.svg";